<template>
    <div class="countwrap">
        <span title="浏览" v-if="$store.state.parglobal.isshowview"><i class="iconfont icon-yanjing"></i>{{c_options.viewcount}}</span>
        <template v-if="$store.state.parglobal.isshowcomment">
            <span title="评论" v-if="c_options.iscommentme" class="idid"><i class="iconfont icon-duihuaxinxitianchong"></i>{{c_options.comments}}</span>
            <span title="评论" v-else><i class="iconfont icon-duihuaxinxi"></i>{{c_options.comments}}</span>
        </template>
        <template v-if="$store.state.parglobal.isshowzan">
            <span title="赞" v-if="iszanme" :class="['idid',{divlink:(c_options.iszancan && $store.state.islogin)}]" @click="setzan()"><i class="iconfont icon-zantianchong"></i>{{zancount}}</span>
            <span title="赞" v-else :class="{divlink:(c_options.iszancan && $store.state.islogin)}" @click="setzan()"><i class="iconfont icon-zan1"></i>{{zancount}}</span>

        </template>

    </div>
</template>

<script>
    export default {
        name: 'ffcounts',
        data() {
            return {
                zanchange: 0
            }
        },
        props: {
            options: {
                type: Object,
                default: () => { }
            }
        },
        computed: {
            c_options: function () {
                let dfoptions = {
                    viewcount: 0,
                    comments: 0,
                    zancount: 0,
                    iscommentme: false,
                    iszanme: false,
                    iszancan: false,
                    targetid: 0,
                    targetkind: 1
                }

                return Object.assign({}, dfoptions, this.options);
            },
            iszanme: function () {
                let _iszanme = false;
                if (this.$common.basic.isobjexist(this.c_options)) {
                    if (this.c_options.iszanme) {
                        _iszanme = this.zanchange != -1;
                    }
                    else {
                        _iszanme = this.zanchange == 1;
                    }
                }

                return _iszanme;
            },
            zancount: function () {
                let _zancount = 0;
                if (this.$common.basic.isobjexist(this.c_options)) {
                    if (this.c_options.iszanme) {
                        _zancount = this.zanchange == -1 ? this.c_options.zancount - 1 : this.c_options.zancount;
                    }
                    else {
                        _zancount = this.zanchange == 1 ? this.c_options.zancount + 1 : this.c_options.zancount;
                    }
                    if (_zancount > this.c_options.viewcount) {
                        _zancount = this.c_options.viewcount;
                        if (_zancount > 1) {
                            _zancount--;
                        }
                    }

                }

                return _zancount;
            }
        },
        methods: {
            setzan: function () {
                if (this.$store.state.islogin && this.c_options.iszancan) {
                    let jsondata = {
                        'postdata': { 'act': 'sht_zansave', 'data': { 'targetid': this.c_options.targetid, 'targetkind': this.c_options.targetkind } }, 'msg': ''
                    };
                    this.$common.post(jsondata, res => {
                        this.zanchange = res.zan;
                    });
                }

            }
        }
    }
</script>

<style scoped>
    .countwrap span { display: flex; margin-left: 15px; font-size: 16px; align-items: center }
    .countwrap .idid { color: #de1399 }
    .countwrap span .iconfont { font-size: 24px; margin-right: 5px; }
    .countwrap .divlink:hover { color: #de1399 }
</style>
